import React, { useEffect, useState } from "react";
import DashboardHeader from "../../../../Components/header/DashboardHeader";
import "../createGroup/CreateGroup.css";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  Input,
  LoadingButton,
  Select,
  TextArea,
} from "../../../../Components/header/form";
import { imageHandler } from "../../../../utils/imageHandler";
import { edit_icon, img_placehlder } from "../../../../assets";
import {
  createGroupApi,
  groupDetailApi,
  updateGroupApi,
} from "../../../../services/groups";
import multipartDataHelper from "../../../../utils/sendMultipartDataHelper";
import { fetchCategoriesListApi } from "../../../../services/common";
import { toastMessage } from "../../../../utils/toastMessage";
import { CiNoWaitingSign } from "react-icons/ci";

const EditGroup = () => {
  const { groupId } = useParams();
  const [loading, setLoading] = useState(false);
  const [categoryList, setCategoryList] = useState([]);
  const [inputData, setInputData] = useState({});
  const [image, setImage] = useState("");
  const navigate = useNavigate();
  const [buttonDisabledButton, setDisabledButton] = useState(true)

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputData({ ...inputData, [name]: value.replace(/^\s+/, "") });
  };
  // ------------- validation------------
  const isFormComplete = () => {
    const requiredFields = ["name", "categoryName", "type", "description"];
    const isAllFilled = requiredFields.every((field) => String(inputData[field] || ""));
    if (inputData.type === "SUBSCRIPTION") {
      const subscriptionFields = ["monthlyPrice", "quarterlyPrice", "yearlyPrice"];
      return isAllFilled && subscriptionFields?.every((field) => String(inputData[field] || "")?.trim());
    }
    return isAllFilled;
  };
  // console.log('inputData edit', inputData)
  useEffect(() => {
    setDisabledButton(!isFormComplete());
  }, [inputData]);
  //   Fetching Category List
  const fetchCategoryList = async () => {
    try {
      const { data } = await fetchCategoriesListApi();
      const { success, data: response } = data;
      if (success) {
        setCategoryList(response);
      } else {
        setCategoryList([]);
      }
    } catch (e) {
      console.log("Error:-", e.message);
    }
  };

  const getGroupDetail = async () => {
    try {
      const { data } = await groupDetailApi({ _id: groupId });
      const { success, message, data: response } = data;

      if (success) {
        const inputValue = {
          categoryName: response?.categoryName,
          _id: groupId,
          type: response?.type,
          name: response?.name,
          description: response?.description,
        };
        // Add subscription prices only if the group type is "SUBSCRIPTION"
        if (response?.type === "SUBSCRIPTION") {
          inputValue.monthlyPrice = response?.monthlyPrice?.price;
          inputValue.quarterlyPrice = response?.quarterlyPrice?.price;
          inputValue.yearlyPrice = response?.yearlyPrice?.price;
        }
        setInputData(inputValue || {})
        setImage(response?.coverImage);
      } else {
        toastMessage(message, "error", "getGroupDetail");
      }
    } catch (e) {
      console.log("Error:-", e.message);
    }
  };
  //------------update-API----------------------
  const updateGroupDetail = async () => {
    if (!image || (!image.name && typeof image !== "string")) {
      return toastMessage("Please upload a cover image", "error", "coverImageCreateGroup");
    }
    try {
      setLoading(true);
      const formData = new FormData();
      if (image && image?.name) {
        formData.append("coverImage", image);
      }
      multipartDataHelper(formData, inputData);

      const { data } = await updateGroupApi(formData);
      const { success, message } = data;
      if (success) {
        navigate(-1);
      }
      toastMessage(message, success ? "success" : "error", "addGroupHandler");
    } catch (e) {
      console.log("Error:-", e.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCategoryList();
    getGroupDetail();
  }, []);

  return (
    <>
      <div className="create_group">
        <DashboardHeader title={"Groups"} />

        <div className="create_group_page">
          <div className="create_grp_Navbar">
            <nav>
              <ul className="_breadcrumb">
                <li className="__breadcrumb_group">
                  <Link to={-1}>Groups </Link>
                </li>
                <li>
                  <span>Edit Group</span>
                </li>
              </ul>
            </nav>
          </div>
        </div>

        <div className="upload_cover">
          <div className="custom_container">
            <div className="row">
              <div className="col_lg_12">
                <div className="upload_cover_border"></div>
              </div>
            </div>

            <div className="user_icon">
              <img src={image?.name ? URL.createObjectURL(image) : image} />
              <input
                type="file"
                id="profile_picture"
                accept="image/*"
                onChange={(e) => imageHandler(e, setImage, "image", null)}
              />
              <label htmlFor="profile_picture" className="edit-icon">
                {/* <img src={edit_icon} /> */}
              </label>
            </div>

            <div className="form_field_wrap">
              <div className="form-group">
                <Input
                  required
                  label="Group Name"
                  type="text"
                  id="name"
                  name="name"
                  value={inputData?.name}
                  onChange={handleChange}
                  className="input form-control"
                  placeholder="Enter Group Name"
                />
              </div>

              <div className="form-group">
                <Select
                  label="Category"
                  type="text"
                  id="categoryName"
                  name="categoryName"
                  value={inputData?.categoryName}
                  onChange={handleChange}
                  className="input form-control"
                >
                  <option value="">Select Category</option>
                  {categoryList?.map((data, ind) => (
                    <option key={ind} value={data?.name}>{data?.name}</option>
                  ))}
                </Select>
              </div>

              <div className="form-group">
                <Select
                  label="Group Type"
                  type="text"
                  id="groupType"
                  name="type"
                  value={inputData?.type}
                  onChange={handleChange}
                  className="input form-control"
                >
                  <option value={""}>Group Type</option>
                  <option value={"PRIVATE"}>Private</option>
                  <option value={"PUBLIC"}>Public</option>
                  <option value={"SUBSCRIPTION"}>Subscription</option>
                </Select>
              </div>
            </div>
            {/* -------------if-subscription------------------- */}
            {inputData?.type === 'SUBSCRIPTION' &&
              <>
                <div className="form_field_wrap">
                  <div className="form-group">
                    <Input
                      required
                      label="Monthly"
                      type="text"
                      id="monthly"
                      name="monthlyPrice"
                      value={inputData?.monthlyPrice}
                      onChange={handleChange}
                      className="input form-control"
                      placeholder="Enter enter monthly"
                    />
                  </div>

                  <div className="form-group">
                    <Input
                      required
                      label="Quarterly"
                      type="text"
                      id="quarterly"
                      name="quarterlyPrice"
                      value={inputData?.quarterlyPrice}
                      onChange={handleChange}
                      className="input form-control"
                      placeholder="Enter enter quarterly"
                    />
                  </div>

                  <div className="form-group">
                    <Input
                      required
                      label="Yearly"
                      type="text"
                      id="yearly"
                      name="yearlyPrice"
                      value={inputData?.yearlyPrice}
                      onChange={handleChange}
                      className="input form-control"
                      placeholder="Enter enter yearly"
                    />
                  </div>
                </div>
              </>}
            <div className="form-group">
              <TextArea
                label="Description"
                type="text"
                id="description"
                name="description"
                value={inputData?.description}
                onChange={handleChange}
                className="input form-control"
                placeholder="Write here..."
              // error={error?.nickname}
              />
            </div>
          </div>
        </div>

        <LoadingButton isDisabled={buttonDisabledButton} loading={loading} onClick={updateGroupDetail}>
          {/* Update */}
          {buttonDisabledButton ? <CiNoWaitingSign /> : "Update"}
        </LoadingButton>
      </div>
    </>
  );
};

export default EditGroup;
